if (!customElements.get('product-modal-options')) {
  class ProductModalOptions extends HTMLElement {
    constructor() {
      super();
      this.modal = this.closest('modal-component');
    }

    modal = null;
    selectedVariantId = null;

    connectedCallback() {
      this.variantData = JSON.parse(this.querySelector('[data-variant-data]').textContent);
      this.productHandle = this.dataset.productHandle;
      this.selectedVariantId = this.dataset.selectedVariantId;
      this.productId = this.dataset.productId;
      this.knifeSelector = this.closest('bb-knife-selector');

      this.options = this.querySelectorAll('[data-option-value]');
      this.options.forEach(option => {
        option.addEventListener('click', this.handleOptionClick.bind(this));
      });
    }

    handleOptionClick(event) {
      const option = event.currentTarget;
      const value = option.dataset.optionValue;

      const variant = Object.entries(this.variantData).find(([variantId, options]) => 
        options.includes(value)
      );

      if (variant) {
        const [variantId] = variant;

        if (this.selectedVariantId !== variantId) {
          const section = this.knifeSelector ? 'bb-product-modal-content' : 'product-modal-content';
          const request = new XMLHttpRequest();
          request.addEventListener('load', this.handleModalResponse.bind(this));
          request.open('GET', `${window.Shopify.routes.root}products/${this.productHandle}?variant=${variantId}&sections=${section}`, true);
          request.send();
        }

        this.selectedVariantId = variantId;
      }
    }

    handleModalResponse(event) {
      const section = this.knifeSelector ? 'bb-product-modal-content' : 'product-modal-content';
      const productModalContent = JSON.parse(event.target.response)[section];
      const html = new DOMParser().parseFromString(productModalContent, 'text/html');
      const modalContent = this.modal.querySelector(`#product-modal-${this.productId}-content`) ?? this.modal.querySelector('#product-modal-content');

      modalContent.innerHTML = html.querySelector(`#product-modal-content`).innerHTML;
      if (this.knifeSelector) {
        this.knifeSelector.setQtySelectors();
      }
    }
  }

  customElements.define('product-modal-options', ProductModalOptions);
}